import { SocialNetwork } from './social';
import { ContentCategory } from './brand';
import { ImageSource, DynamicTexts } from './post';
import { PreviewFormat } from './template';

// Gallery item - saved favorite design
export interface GalleryItem {
  id: string;
  workspaceId: string;
  name?: string;
  // Original post data snapshot
  imageUrl: string;
  content: string;
  network: SocialNetwork;
  contentCategory?: ContentCategory;
  imageSource?: ImageSource;
  // Template configuration
  templateId?: string;
  format: PreviewFormat;
  backgroundOffsetX: number;
  backgroundOffsetY: number;
  backgroundScale?: number;
  // Dynamic texts snapshot
  dynamicTexts?: DynamicTexts;
  // Timestamps
  createdAt: string;
}

// Request to create a gallery item
export interface CreateGalleryItemRequest {
  name?: string;
  imageUrl: string;
  content: string;
  network: SocialNetwork;
  contentCategory?: ContentCategory;
  imageSource?: ImageSource;
  templateId?: string;
  format: PreviewFormat;
  backgroundOffsetX?: number;
  backgroundOffsetY?: number;
  backgroundScale?: number;
  dynamicTexts?: DynamicTexts;
}

// Request to update a gallery item
export interface UpdateGalleryItemRequest {
  name?: string;
}
